export default {
  loggedUser: {}
}
